export enum FileType {
  Users = 0,
  SisAttendance = 1,
  Rosters = 2,
  BulkRosters = 3,
  CatchAll = 4,
}
